(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    if (location.pathname.includes("/products/") && location.pathname.includes("-outlet")) return;
    
    addStyle();
    if (location.pathname.includes("/products/")) {
      addCompareBtnPDP();
    } else if (location.pathname.includes("/collections/")) {
      addCompareBtn();
    }
    addPopup();
    updateAll();
    assignCssVariables();
  }

  function addStyle() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      body:has(.compare_fridge_popup.show) {
        overflow: hidden;
      }

      .itemsCategoryWrapper {
        position: relative;
      }
      .btn-compare_fridge {
        width: 100%;
        margin-bottom: 1rem;
        padding: 12px;
        background: #fff;
        border: 2px solid #7A0000;
        color: #7A0000;
        font-weight: 700;
      }
      .btn-compare_fridge:active {
        transform: scale(0.98);
      }
      .compare_fridge_popup {
        display: none;
        position: fixed;
        top: 72px;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        overflow-y: auto;
        z-index: 9999999;
      }
      .compare_fridge_popup p {
        margin: 0;
      }
      .compare_fridge_popup_close_btn {
        display: block;
        position: sticky;
        top: 10px;
        right: 10px;
        width: fit-content;
        margin-left: auto;
        background: none repeat scroll 0 0 transparent;
        border: medium none;
        border-spacing: 0;
        cursor: pointer;
        z-index: 2;
      }
      .compare_fridge_popup_close_btn svg.icon-close {
        width: 25px;
        height: 25px;
      }
      .compare_fridge_popup .container_title {
        padding-bottom: 12px;
        font-weight: 700;
        font-size: 28px;
        text-align: center;
      }
      .compare_fridge_popup .container_subtitle {
        margin-bottom: 1rem;
        text-align: center;
        font-size: 14px;
      }

      /* Table */
      .compare_fridge_popup .compare_list table {
        width: 100%;
        table-layout: fixed;
      }
      .compare_fridge_popup .compare_list table tr {
        background: #fff;
      }
      .compare_fridge_popup .compare_list table tr > *:nth-child(3) {
        display: none;
      }
      .compare_fridge_popup .compare_list table tr:has(th.row_header) {
        border-bottom: 1px solid black;
      }
      .compare_fridge_popup .compare_list table th.row_header {
        font-size: 26px;
        font-weight: 700;
      }
      .compare_fridge_popup .compare_list table th {
        padding: 1rem 3px 0px;
      }
      .compare_fridge_popup .compare_list table td {
        padding: 0px 3px;
        vertical-align: top;
      }
      @media (min-width: 1024px) {
        .compare_fridge_popup .compare_list table tr > *:nth-child(3) {
          display: table-cell;
        }
        .compare_fridge_popup .compare_list table th.row_header {
          font-size: 32px;
        }
        .compare_fridge_popup .compare_list table th,
        .compare_fridge_popup .compare_list table td {
          padding-inline: 8px;
        }
      }

      .compare_fridge_popup .compare_list table tr.row_select {
        position: sticky;
        top: 0px;
        z-index: 1;
      }
      .compare_fridge_popup .compare_list table tr.row_variant {
        position: sticky;
        top: 85px;
      }
      .compare_fridge_popup .compare_list table tr.row_price {
        position: sticky;
        top: 148px;
      }
      .compare_fridge_popup .compare_list table tr.row_cta {
        position: sticky;
        top: 190px;
        box-shadow: 0px 4px 2px -2px #00000040;
      }
      .compare_fridge_popup .compare_list table tr.row_select td,
      .compare_fridge_popup .compare_list table tr.row_variant td,
      .compare_fridge_popup .compare_list table tr.row_price td,
      .compare_fridge_popup .compare_list table tr.row_cta td {
        padding-block: 0.5rem;
      }
      .compare_fridge_popup .compare_list table .row_image .image_wrapper img {
        max-height: 330px;
        width: auto;
        display: block;
        margin: 0 auto;
      }
      .compare_fridge_popup .compare_list table .row_variant .variant_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        text-align: center;
      }
      .compare_fridge_popup .compare_list table .row_variant .variant_wrapper .variant_options {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        gap: 8px;
      }
      .compare_fridge_popup .compare_list table .row_variant .variant_wrapper .variant_options .variant_option {
        position: relative;
        display: block;
        width: 20px;
        height: 20px;
        border: 1px solid #000;
        border-radius: 100%;
        cursor: pointer;
      }
      .compare_fridge_popup .compare_list table .row_variant .variant_wrapper .variant_options .variant_option.selected:after {
        position: absolute;
        top: -4px;
        left: -4px;
        content: "";
        width: 26px;
        height: 26px;
        border-radius: 100%;
        border: 1px solid #000;
      }
      .compare_fridge_popup .compare_list table .row_price .price_wrapper {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
        gap: 4px;
      }
      .compare_fridge_popup .compare_list table .row_price .price_wrapper .price {
        color: #9b0202;
        font-size: 17px;
        font-weight: 700;
      }
      .compare_fridge_popup .compare_list table .row_price .price_wrapper .compare_at_price {
        font-size: 13px;
        align-self: flex-end;
      }
      .compare_fridge_popup .compare_list table .row_cta .cta_wrapper {
        width: 100%;
      }
      .compare_fridge_popup .compare_list table .row_cta .cta_wrapper a {
        width: 100%;
        padding: .5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #7a0000;
        background: #7a0000;
        color: #fff;
        font-weight: 600;
        font-size: 12px;
        text-align: center;
      }
      @media (min-width: 1024px) {
        .compare_fridge_popup .compare_list table .row_price .price_wrapper .price {
          font-size: 22px;
        }
        .compare_fridge_popup .compare_list table .row_cta .cta_wrapper a {
          padding: 13px 23px;
          font-size: 16px;
        }
      }

      /* Select */
      .compare_fridge_popup .select {
        position: relative;
        width: 100%;
      }
      .compare_fridge_popup .select .trigger {
        display: flex;
        position: relative;
        align-items: center;
        cursor: pointer;
        background-color: #fff;
        border: 1.5px solid #e8e9eb;
        border-radius: 2px;
        padding: 1rem 2rem 1rem 1rem;
        height: 70px;
        font-weight: 600;
      }
      .compare_fridge_popup .select .trigger:after {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        background: url(https://cdn-x.omniconvert.com/public/uploads/2023-09/c436165bf05bba37de8351ac6640ef40.svg) no-repeat center;
        background-size: cover;
        width: 14px;
        height: 7px;
        content: "";
      }
      .compare_fridge_popup .select .trigger span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .compare_fridge_popup .select .options {
        display: none;
        position: absolute;
        top: 100%;
        right: 0;
        left: 0;
        max-height: 320px;
        border-radius: 4px;
        background: #676669;
        padding: 10px 0;
        overflow-y: auto;
        z-index: 1;
      }
      .compare_fridge_popup .select.open .options {
        display: block;
      }
      .compare_fridge_popup .select .options .option {
        position: relative;
        cursor: pointer;
        padding: 3px 42px;
        color: #fff;
        line-height: 1.7;
      }
      .compare_fridge_popup .select .options .option:hover {
        background: #4687e9;
      }
      .compare_fridge_popup .select .options .option.selected:before {
        display: block;
        position: absolute;
        top: 50%;
        left: 15px;
        transform: translateY(-50%);
        background: url(https://cdn-x.omniconvert.com/public/uploads/2023-09/85a786792f447dd5bad3b7b35c183ac9.svg) no-repeat center;
        background-size: cover;
        width: 18px;
        height: 17px;
        content: "";
      }
      @media (min-width: 1024px) {
        .compare_fridge_popup .select .trigger {
          padding: 1rem 3rem 1rem 1rem;
        }
      }

      @media (min-width: 1024px) {
        .btn-compare_fridge {
          position: absolute;
          top: 0;
          right: 0;
          max-width: 180px;
          margin-bottom: 0;
        }
        .compare_fridge_popup {
          top: var(--nav-height, 86.87px);
        }
        .compare_fridge_popup_close_btn {
          top: 22px;
          right: 22px;
        }
        .compare_fridge_popup .container_title {
          font-size: 33px;
        }
        .compare_fridge_popup .container_subtitle {
          font-size: 16px;
        }
      }
      @media (max-width: 1023px) {
        .tv_compare_popup [data-index="3"] {
          display: none;
        }
      }
    `;
    document.head.append(style);
  }

  function addCompareBtn() {
    const button = document.createElement("button");
    button.classList.add("btn-compare_fridge");
    button.textContent = "Compare Fridges";
    button.addEventListener("click", function () {
      $(".compare_fridge_popup").addClass("show");
    });
    const firstSection = $(".featured-products-sc").first();
    firstSection.find(".itemsCategoryWrapper").prepend(button);
  }

  function addCompareBtnPDP() {
    const button = document.createElement("button");
    button.classList.add("btn", "spec-button");
    button.textContent = "Compare";
    button.addEventListener("click", function () {
      $(".compare_fridge_popup").toggleClass("show");
    });
    $(".nav2-content .spacer").after(button);
  }

  function addPopup() {
    const popup = document.createElement("div");
    popup.classList.add("compare_fridge_popup");

    const closeBtn = document.createElement("button");
    closeBtn.innerHTML = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 37 40"><path d="M21.3 23l11-11c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-11 11-11-11c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l11 11-11 11c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l11-11 11 11c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8l-11-11z"></path></svg>`;
    closeBtn.classList.add("compare_fridge_popup_close_btn");
    closeBtn.addEventListener("click", function () {
      $(".compare_fridge_popup").removeClass("show");
    });

    const container = document.createElement("div");
    container.classList.add("compare_fridge_popup_container");
    container.innerHTML = `
      <div class="page-width">
        <div class="container_title">Compare Fridges</div>
        <div class="container_subtitle">Your fridge isn’t just an appliance — it’s the heart of your kitchen. Find the ideal match for your lifestyle and enjoy freshness that lasts!</div>
        <div class="compare_list"></div>
      </div>
    `;

    const table = document.createElement("table");

    const row_fridges = getRows_Fridges();
    const row_physical_characteristics = getRows_PhysicalCharacteristics();
    const row_performance = getRows_Performance();
    const row_storage = getRows_Storage();
    const row_controls = getRows_Controls();
    const row_design_build = getRows_DesignBuild();

    for (const row of row_fridges) {
      table.append(row);
    }
    for (const row of row_physical_characteristics) {
      table.append(row);
    }
    for (const row of row_performance) {
      table.append(row);
    }
    for (const row of row_storage) {
      table.append(row);
    }
    for (const row of row_controls) {
      table.append(row);
    }
    for (const row of row_design_build) {
      table.append(row);
    }
    container.querySelector(".compare_list").append(table);

    popup.append(closeBtn, container);
    document.body.append(popup);
  }

  function getRows_Fridges() {
    let returnValue = [];

    const rowSelect = document.createElement("tr");
    const rowImage = document.createElement("tr");
    const rowVariant = document.createElement("tr");
    const rowPrice = document.createElement("tr");
    const rowCta = document.createElement("tr");

    rowSelect.classList.add("row_select");
    rowImage.classList.add("row_image");
    rowVariant.classList.add("row_variant");
    rowPrice.classList.add("row_price");
    rowCta.classList.add("row_cta");

    function getFridgeDropdown(index = 0) {
      const select = document.createElement("div");
      select.classList.add("select");

      const data = getDetails();

      const trigger = document.createElement("div");
      trigger.classList.add("trigger");
      //trigger.innerHTML = `<span>${data[index].name}</span>`;
      trigger.innerHTML = `<span>${data[index].name.replace(/\s*\([^)]*\)\s*$/, "")}</span>`;

      const options = document.createElement("div");
      options.classList.add("options");
      data.forEach((x, i) => {
        const option = document.createElement("div");
        option.classList.add("option");
        if (i == index) option.classList.add("selected");
        //option.textContent = x.name;
        option.textContent = x.name.replace(/\s*\([^)]*\)\s*$/, "");
        option.setAttribute("data-handle", x.handle);
        options.append(option);

        option.addEventListener("click", function () {
          $(this).siblings(".option").removeClass("selected");
          $(this).addClass("selected");
          //$(this).closest(".select").find(".trigger span").text($(this).text());
          $(this)
            .closest(".select")
            .find(".trigger span")
            .text(x.name.replace(/\s*\([^)]*\)\s*$/, ""));
          updateProduct(index, x.handle);
        });
      });

      select.addEventListener("click", function () {
        $(this).toggleClass("open");
      });

      select.append(trigger, options);
      return select;
    }

    for (const x of Array(3).keys()) {
      const cellSelect = document.createElement("td");
      const cellImage = document.createElement("td");
      const cellVariant = document.createElement("td");
      const cellPrice = document.createElement("td");
      const cellCta = document.createElement("td");

      const select = getFridgeDropdown(x);
      cellSelect.append(select);

      const imageWrapper = document.createElement("div");
      imageWrapper.classList.add("image_wrapper");
      imageWrapper.innerHTML = `
        <img src="" alt="" width="" height="" />
      `;
      cellImage.append(imageWrapper);

      const variantWrapper = document.createElement("div");
      variantWrapper.classList.add("variant_wrapper");
      variantWrapper.innerHTML = `
        <p>Available Color Options</p>
        <ul class="variant_options"></ul>
      `;
      cellVariant.append(variantWrapper);

      const priceWrapper = document.createElement("div");
      priceWrapper.classList.add("price_wrapper");
      priceWrapper.innerHTML = `
        <img width="20" height="20" src="//prismplus.sg/cdn/shop/t/35/assets/voucher-icon.svg?v=96074962922774460831765247161" />
        <span class="price">$XXX</span>
        <s class="compare_at_price">$XXX</s>
      `;
      cellPrice.append(priceWrapper);

      const ctaWrapper = document.createElement("div");
      ctaWrapper.classList.add("cta_wrapper");
      ctaWrapper.innerHTML = `<a href="#/">Shop XXX</a>`;
      cellCta.append(ctaWrapper);

      rowSelect.append(cellSelect);
      rowImage.append(cellImage);
      rowVariant.append(cellVariant);
      rowPrice.append(cellPrice);
      rowCta.append(cellCta);
    }

    returnValue.push(rowSelect, rowImage, rowVariant, rowPrice, rowCta);
    return returnValue;
  }

  function getRows_PhysicalCharacteristics() {
    let returnValue = [];

    const rowHeader = document.createElement("tr");
    rowHeader.innerHTML = `<th class="row_header" colspan="2">Physical Characteristics</th>`;
    returnValue.push(rowHeader);

    const detailHeaders = [
      "Total Net Capacity",
      "Net Fridge Capacity",
      "Net Freezer Capacity",
      "Type",
      "Door Split (Fridge/Freezer)",
      "Product Dimension (L×D×H)",
      "Packing Dimension (L×D×H)",
      "Net Weight",
      "Gross Weight",
    ];

    const detailHeadersAlt = [
      "total_net_capacity",
      "net_fridge_capacity",
      "net_freezer_capacity",
      "type",
      "door_split",
      "product_dimension",
      "packing_dimension",
      "net_weight",
      "gross_weight",
    ];

    for (const [i, header] of detailHeaders.entries()) {
      const row_headers = document.createElement("tr");
      const row_content = document.createElement("tr");

      for (const x of Array(3).keys()) {
        const cell_header = document.createElement("th");
        cell_header.innerText = header;
        row_headers.append(cell_header);

        const cell_content = document.createElement("td");
        cell_content.innerHTML = `<p class="${detailHeadersAlt[i]}"></p>`;
        row_content.append(cell_content);
      }

      returnValue.push(row_headers, row_content);
    }

    return returnValue;
  }

  function getRows_Performance() {
    let returnValue = [];

    const rowHeader = document.createElement("tr");
    rowHeader.innerHTML = `<th class="row_header" colspan="2">Performance</th>`;
    returnValue.push(rowHeader);

    const detailHeaders = [
      "Compressor",
      "Refrigerant",
      "Muti-Zone Cooling",
      "No Frost Technology",
      "Defrosting System ",
      "Noise Level",
      "Ceramic & Activated Carbon Air Filter",
      "Storage Time During Power-off",
    ];

    const detailHeadersAlt = [
      "compressor",
      "refrigerant",
      "multi_zone_cooling",
      "no_frost_technology",
      "defrosting_system",
      "noise_level",
      "ceramic_activated_carbon_air_filter",
      "storage_time_during_power_off",
    ];

    for (const [i, header] of detailHeaders.entries()) {
      const row_headers = document.createElement("tr");
      const row_content = document.createElement("tr");

      for (const x of Array(3).keys()) {
        const cell_header = document.createElement("th");
        cell_header.innerText = header;
        row_headers.append(cell_header);

        const cell_content = document.createElement("td");
        cell_content.innerHTML = `<p class="${detailHeadersAlt[i]}"></p>`;
        row_content.append(cell_content);
      }

      returnValue.push(row_headers, row_content);
    }

    return returnValue;
  }

  function getRows_Storage() {
    let returnValue = [];

    const rowHeader = document.createElement("tr");
    rowHeader.innerHTML = `<th class="row_header" colspan="2">Storage</th>`;
    returnValue.push(rowHeader);

    const detailHeaders = [
      "Fridge Tempered Glass shelf",
      "Crisper drawer",
      "Fridge Transparent Door Basket",
      "Convertible Zone Drawer",
      "Movable Twist Ice Maker",
      "Freezer Tempered Glass shelf",
      "Freezer Transparent Door Basket ",
      "Freezer Drawer",
    ];

    const detailHeadersAlt = [
      "fridge_tempered_glass_shelf",
      "crisper_drawer",
      "fridge_transparent_door_basket",
      "convertible_zone_drawer",
      "movable_twist_ice_maker",
      "freezer_tempered_glass_shelf",
      "freezer_transparent_door_basket",
      "freezer_drawer",
    ];

    for (const [i, header] of detailHeaders.entries()) {
      const row_headers = document.createElement("tr");
      const row_content = document.createElement("tr");

      for (const x of Array(3).keys()) {
        const cell_header = document.createElement("th");
        cell_header.innerText = header;
        row_headers.append(cell_header);

        const cell_content = document.createElement("td");
        cell_content.innerHTML = `<p class="${detailHeadersAlt[i]}"></p>`;
        row_content.append(cell_content);
      }

      returnValue.push(row_headers, row_content);
    }

    return returnValue;
  }

  function getRows_Controls() {
    let returnValue = [];

    const rowHeader = document.createElement("tr");
    rowHeader.innerHTML = `<th class="row_header" colspan="2">Controls</th>`;
    returnValue.push(rowHeader);

    const detailHeaders = [
      "Temperature Control Panel",
      "External LED Display",
      "Super Freeze Mode",
      "Holiday Mode",
      "Eco Mode",
      "Power Cool",
      "Door Alarm",
    ];

    const detailHeadersAlt = [
      "temperature_control_panel",
      "external_led_display",
      "super_freeze_mode",
      "holiday_mode",
      "eco_mode",
      "power_cool",
      "door_alarm",
    ];

    for (const [i, header] of detailHeaders.entries()) {
      const row_headers = document.createElement("tr");
      const row_content = document.createElement("tr");

      for (const x of Array(3).keys()) {
        const cell_header = document.createElement("th");
        cell_header.innerText = header;
        row_headers.append(cell_header);

        const cell_content = document.createElement("td");
        cell_content.innerHTML = `<p class="${detailHeadersAlt[i]}"></p>`;
        row_content.append(cell_content);
      }

      returnValue.push(row_headers, row_content);
    }

    return returnValue;
  }

  function getRows_DesignBuild() {
    let returnValue = [];

    const rowHeader = document.createElement("tr");
    rowHeader.innerHTML = `<th class="row_header" colspan="2">Design Build</th>`;
    returnValue.push(rowHeader);

    const detailHeaders = [
      "Energy Label Certificate Number",
      "Annual Energy Consumption",
      "Door Panel Material",
      "Colours",
      "Handle Type",
      "Metal Back",
      "Wheel",
      "Reversible Door",
      "Adjustable leg",
      "Exposed Cord Length",
      "Vacuum Insulation Panels (VIP)",
    ];

    const detailHeadersAlt = [
      "energy_label_certificate_number",
      "annual_energy_consumption",
      "door_panel_material",
      "colours",
      "handle_type",
      "metal_back",
      "wheel",
      "reversible_door",
      "adjustable_leg",
      "exposed_cord_length",
      "vacuum_insulation_panels",
    ];

    for (const [i, header] of detailHeaders.entries()) {
      const row_headers = document.createElement("tr");
      const row_content = document.createElement("tr");

      for (const x of Array(3).keys()) {
        const cell_header = document.createElement("th");
        cell_header.innerText = header;
        row_headers.append(cell_header);

        const cell_content = document.createElement("td");
        cell_content.innerHTML = `<p class="${detailHeadersAlt[i]}"></p>`;
        row_content.append(cell_content);
      }

      returnValue.push(row_headers, row_content);
    }

    return returnValue;
  }

  function updateAll() {
    for (const x of Array(3).keys()) {
      updateProduct(x);
    }
  }

  async function updateProduct(index, handle = null) {
    const table = $(".compare_fridge_popup table");

    const cellSelect = table.find(`.row_select > td:nth-child(${index + 1})`);
    const cellImage = table.find(`.row_image > td:nth-child(${index + 1})`);
    const cellVariant = table.find(`.row_variant > td:nth-child(${index + 1})`);
    const cellPrice = table.find(`.row_price > td:nth-child(${index + 1})`);
    const cellCta = table.find(`.row_cta > td:nth-child(${index + 1})`);

    const prodHandle =
      handle ?? cellSelect.find(".select .option.selected").attr("data-handle");

    if (!prodHandle) {
      console.error("Product handle not found.");
      return;
    }

    const productData = await getProductData(prodHandle);

    const availableVariants = productData.variants.filter(
      (x) => x.available && x.price > 0,
    );

    const defaultVariant = availableVariants[0];

    const imageWrapper = cellImage.find(".image_wrapper");
    const variantWrapper = cellVariant.find(".variant_wrapper");
    const priceWrapper = cellPrice.find(".price_wrapper");
    const ctaWrapper = cellCta.find(".cta_wrapper");

    if (productData.featured_image) {
      imageWrapper.find("img").attr("src", productData.featured_image);
      imageWrapper.find("img").attr("alt", productData.title);
    }

    variantWrapper.find(".variant_options").empty();
    for (const [i, v] of availableVariants.entries()) {
      const variantOption = document.createElement("li");
      variantOption.classList.add(
        "variant_option",
        `variant-${theme.handleize(v.title)}`,
      );
      if (i == 0) variantOption.classList.add("selected");

      variantOption.addEventListener("click", function () {
        $(this).siblings(".variant_option").removeClass("selected");
        $(this).addClass("selected");
        if (v.featured_image?.src) {
          imageWrapper.find("img").attr("src", v.featured_image.src);
        }

        priceWrapper.find(".price").text(theme.Currency.formatMoney(v.price));
        priceWrapper
          .find(".compare_at_price")
          .text(theme.Currency.formatMoney(v.compare_at_price));
      });

      variantWrapper.find(".variant_options").append(variantOption);
    }

    priceWrapper
      .find(".price")
      .text(theme.Currency.formatMoney(defaultVariant.price));
    priceWrapper
      .find(".compare_at_price")
      .text(theme.Currency.formatMoney(defaultVariant.compare_at_price));

    ctaWrapper.find("a").attr("href", `/products/${productData.handle}`);
    ctaWrapper
      .find("a")
      .text(`Shop ${productData.title.replaceAll("PRISM+", "")}`);

    const details = getDetails();
    const curDetails = details.find((x) => x.handle == prodHandle);
    const curColumns = table.find(`td:nth-child(${index + 1})`);

    // Physical Characteristics
    curColumns
      .find("p.total_net_capacity")
      .text(curDetails.physical_characteristics.total_net_capacity);
    curColumns
      .find("p.net_fridge_capacity")
      .text(curDetails.physical_characteristics.net_fridge_capacity);
    curColumns
      .find("p.net_freezer_capacity")
      .text(curDetails.physical_characteristics.net_freezer_capacity);
    curColumns.find("p.type").text(curDetails.physical_characteristics.type);
    curColumns
      .find("p.door_split")
      .text(curDetails.physical_characteristics.door_split);
    curColumns
      .find("p.product_dimension")
      .text(curDetails.physical_characteristics.product_dimension);
    curColumns
      .find("p.packing_dimension")
      .text(curDetails.physical_characteristics.packing_dimension);
    curColumns
      .find("p.net_weight")
      .text(curDetails.physical_characteristics.net_weight);
    curColumns
      .find("p.gross_weight")
      .text(curDetails.physical_characteristics.gross_weight);

    // Performance
    curColumns.find("p.compressor").text(curDetails.performance.compressor);
    curColumns.find("p.refrigerant").text(curDetails.performance.refrigerant);
    curColumns
      .find("p.multi_zone_cooling")
      .text(curDetails.performance.multi_zone_cooling);
    curColumns
      .find("p.no_frost_technology")
      .text(curDetails.performance.no_frost_technology);
    curColumns
      .find("p.defrosting_system")
      .text(curDetails.performance.defrosting_system);
    curColumns.find("p.noise_level").text(curDetails.performance.noise_level);
    curColumns
      .find("p.ceramic_activated_carbon_air_filter")
      .text(curDetails.performance.ceramic_activated_carbon_air_filter);
    curColumns
      .find("p.storage_time_during_power_off")
      .text(curDetails.performance.storage_time_during_power_off);

    // Storage
    curColumns
      .find("p.fridge_tempered_glass_shelf")
      .text(curDetails.storage.fridge_tempered_glass_shelf);
    curColumns.find("p.crisper_drawer").text(curDetails.storage.crisper_drawer);
    curColumns
      .find("p.fridge_transparent_door_basket")
      .text(curDetails.storage.fridge_transparent_door_basket);
    curColumns
      .find("p.convertible_zone_drawer")
      .text(curDetails.storage.convertible_zone_drawer);
    curColumns
      .find("p.movable_twist_ice_maker")
      .text(curDetails.storage.movable_twist_ice_maker);
    curColumns
      .find("p.freezer_tempered_glass_shelf")
      .text(curDetails.storage.freezer_tempered_glass_shelf);
    curColumns
      .find("p.freezer_transparent_door_basket")
      .text(curDetails.storage.freezer_transparent_door_basket);
    curColumns.find("p.freezer_drawer").text(curDetails.storage.freezer_drawer);

    // Controls
    curColumns
      .find("p.temperature_control_panel")
      .text(curDetails.controls.temperature_control_panel);
    curColumns
      .find("p.external_led_display")
      .text(curDetails.controls.external_led_display);
    curColumns
      .find("p.super_freeze_mode")
      .text(curDetails.controls.super_freeze_mode);
    curColumns.find("p.holiday_mode").text(curDetails.controls.holiday_mode);
    curColumns.find("p.eco_mode").text(curDetails.controls.eco_mode);
    curColumns.find("p.power_cool").text(curDetails.controls.power_cool);
    curColumns.find("p.door_alarm").text(curDetails.controls.door_alarm);

    // Design Build
    curColumns
      .find("p.energy_label_certificate_number")
      .text(curDetails.design_build.energy_label_certificate_number);
    curColumns
      .find("p.annual_energy_consumption")
      .text(curDetails.design_build.annual_energy_consumption);
    curColumns
      .find("p.door_panel_material")
      .text(curDetails.design_build.door_panel_material);
    curColumns.find("p.colours").text(curDetails.design_build.colours);
    curColumns.find("p.handle_type").text(curDetails.design_build.handle_type);
    curColumns.find("p.metal_back").text(curDetails.design_build.metal_back);
    curColumns.find("p.wheel").text(curDetails.design_build.wheel);
    curColumns
      .find("p.reversible_door")
      .text(curDetails.design_build.reversible_door);
    curColumns
      .find("p.adjustable_leg")
      .text(curDetails.design_build.adjustable_leg);
    curColumns
      .find("p.exposed_cord_length")
      .text(curDetails.design_build.exposed_cord_length);
    curColumns
      .find("p.vacuum_insulation_panels")
      .text(curDetails.design_build.vacuum_insulation_panels);
  }

  function getDetails() {
    const data = [
      // {
      //   name: "",
      //   handle: "",
      //   image: "",
      //   physical_characteristics: {
      //     total_net_capacity: "",
      //     net_fridge_capacity: "",
      //     net_freezer_capacity: "",
      //     type: "",
      //     door_split: "",
      //     product_dimension: "",
      //     packing_dimension: "",
      //     net_weight: "",
      //     gross_weight: "",
      //   },
      //   performance: {
      //     compressor: "",
      //     refrigerant: "",
      //     multi_zone_cooling: "",
      //     no_frost_technology: "",
      //     defrosting_system: "",
      //     noise_level: "",
      //     ceramic_activated_carbon_air_filter: "",
      //     storage_time_during_power_off: "",
      //   },
      //   storage: {
      //     fridge_tempered_glass_shelf: "",
      //     crisper_drawer: "",
      //     fridge_transparent_door_basket: "",
      //     convertible_zone_drawer: "",
      //     movable_twist_ice_maker: "",
      //     freezer_tempered_glass_shelf: "",
      //     freezer_transparent_door_basket: "",
      //     freezer_drawer: "",
      //   },
      //   controls: {
      //     temperature_control_panel: "",
      //     external_led_display: "",
      //     super_freeze_mode: "",
      //     holiday_mode: "",
      //     eco_mode: "",
      //     power_cool: "",
      //     door_alarm: "",
      //   },
      //   design_build: {
      //     energy_label_certificate_number: "",
      //     annual_energy_consumption: "",
      //     door_panel_material: "",
      //     colours: "",
      //     handle_type: "",
      //     metal_back: "",
      //     wheel: "",
      //     reversible_door: "",
      //     adjustable_leg: "",
      //     exposed_cord_length: "",
      //     vacuum_insulation_panels: "",
      //   },
      // },
      {
        name: "PureFresh TMF 200",
        handle: "purefresh-tmf-200",
        image: "",
        physical_characteristics: {
          total_net_capacity: "199L",
          net_fridge_capacity: "145L",
          net_freezer_capacity: "52L",
          type: "Top Mount",
          door_split: "70/30",
          product_dimension: "550 x 555 x 1425mm",
          packing_dimension: "575 x 590 x 1470mm",
          net_weight: "41Kg",
          gross_weight: "45Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "39dB",
          ceramic_activated_carbon_air_filter: "No",
          storage_time_during_power_off: "8hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "2",
          convertible_zone_drawer: "",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_drawer: "0",
        },
        controls: {
          temperature_control_panel: "Mechanical",
          external_led_display: "NA",
          super_freeze_mode: "N/A",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "N/A",
          door_alarm: "NA",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF260025 (3 Ticks)",
          annual_energy_consumption: "233 kWh",
          door_panel_material: "Metal",
          colours: "Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "No",
          adjustable_leg: "2",
          exposed_cord_length: "",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh TMF 250",
        handle: "purefresh-tmf-250",
        image: "",
        physical_characteristics: {
          total_net_capacity: "247L",
          net_fridge_capacity: "195L",
          net_freezer_capacity: "52L",
          type: "Top Mount",
          door_split: "65/35",
          product_dimension: "545 x 560 x 1670mm",
          packing_dimension: "575 x 590 x 1712mm",
          net_weight: "44Kg",
          gross_weight: "48Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "39dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "8hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "3",
          convertible_zone_drawer: "",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_drawer: "0",
        },
        controls: {
          temperature_control_panel: "Mechanical",
          external_led_display: "NA",
          super_freeze_mode: "N/A",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "N/A",
          door_alarm: "NA",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF250136 (3 Ticks)",
          annual_energy_consumption: "255 kWh",
          door_panel_material: "Metal",
          colours: "Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "No",
          adjustable_leg: "2",
          exposed_cord_length: "",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh TMF 330 (INOX)",
        handle: "prism-purefresh-tmf330-refrigerator",
        image: "",
        physical_characteristics: {
          total_net_capacity: "333L",
          net_fridge_capacity: "256L",
          net_freezer_capacity: "77L",
          type: "Top Mount",
          door_split: "65/35",
          product_dimension: "605×670×1705mm",
          packing_dimension: "640×702×1784mm",
          net_weight: "57Kg",
          gross_weight: "63Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "39dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "9hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "3",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "3",
          convertible_zone_drawer: "",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_drawer: "0",
        },
        controls: {
          temperature_control_panel: "Mechanical",
          external_led_display: "NA",
          super_freeze_mode: "N/A",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "N/A",
          door_alarm: "NA",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240012 (3 Ticks)",
          annual_energy_consumption: "305 kWh",
          door_panel_material: "Metal",
          colours: "Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "Yes",
          adjustable_leg: "2",
          exposed_cord_length: "",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh TMF 420  (Inox)",
        handle: "prism-purefresh-tmf420-refrigerator",
        image: "",
        physical_characteristics: {
          total_net_capacity: "418L",
          net_fridge_capacity: "323L",
          net_freezer_capacity: "95L",
          type: "Top Mount",
          door_split: "63/35",
          product_dimension: "710 x 685 x 1780mm",
          packing_dimension: "741 x 715 x 1860mm",
          net_weight: "72Kg",
          gross_weight: "79Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "39dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "14hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "3",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "3",
          convertible_zone_drawer: "",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_drawer: "0",
        },
        controls: {
          temperature_control_panel: "Electronic",
          external_led_display: "Yes",
          super_freeze_mode: "N/A",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "Fridge 2°C for 50 hours",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240010 (3 Ticks)",
          annual_energy_consumption: "328 kWh",
          door_panel_material: "Metal",
          colours: "Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "Yes",
          adjustable_leg: "2",
          exposed_cord_length: "",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "EverShine TMF 420 (Black Glass)",
        handle: "prism-evershine-tmf420-refrigerator",
        image: "",
        physical_characteristics: {
          total_net_capacity: "418L",
          net_fridge_capacity: "323L",
          net_freezer_capacity: "95L",
          type: "Top Mount",
          door_split: "63/35",
          product_dimension: "710 x 685 x 1780mm",
          packing_dimension: "741 x 715 x 1860mm",
          net_weight: "72Kg",
          gross_weight: "79Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "39dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "14hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "3",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "3",
          convertible_zone_drawer: "",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_drawer: "0",
        },
        controls: {
          temperature_control_panel: "Electronic",
          external_led_display: "Yes",
          super_freeze_mode: "N/A",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "Fridge 2°C for 50 hours",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240011 (3 Ticks)",
          annual_energy_consumption: "328 kWh",
          door_panel_material: "Metal",
          colours: "Black Glass",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "Yes",
          adjustable_leg: "2",
          exposed_cord_length: "",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh TMF 530 (Inox)",
        handle: "prism-purefresh-tmf530-refrigerator",
        image: "",
        physical_characteristics: {
          total_net_capacity: "530L",
          net_fridge_capacity: "412L",
          net_freezer_capacity: "118L",
          type: "Top Mount",
          door_split: "65/35",
          product_dimension: "800 X 715 X 1835mm",
          packing_dimension: "835 X 742 X 1914mm",
          net_weight: "83Kg",
          gross_weight: "90Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "39dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "13hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "4",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "5",
          convertible_zone_drawer: "",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_drawer: "0",
        },
        controls: {
          temperature_control_panel: "Electronic",
          external_led_display: "Yes",
          super_freeze_mode: "N/A",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "Fridge 2°C for 50 hours",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240027 (3 Ticks)",
          annual_energy_consumption: "400 kWh",
          door_panel_material: "Metal",
          colours: "Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "Yes",
          adjustable_leg: "2",
          exposed_cord_length: "",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "EverShine TMF 530 (Glass Black)",
        handle: "prism-evershine-tmf530-refrigerator",
        image: "",
        physical_characteristics: {
          total_net_capacity: "530L",
          net_fridge_capacity: "412L",
          net_freezer_capacity: "118L",
          type: "Top Mount",
          door_split: "65/35",
          product_dimension: "800 X 715 X 1835mm",
          packing_dimension: "835 X 742 X 1914mm",
          net_weight: "83Kg",
          gross_weight: "90Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "39dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "13hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "4",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "5",
          convertible_zone_drawer: "",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_drawer: "0",
        },
        controls: {
          temperature_control_panel: "Electronic",
          external_led_display: "Yes",
          super_freeze_mode: "N/A",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "Fridge 2°C for 50 hours",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240027 (3 Ticks)",
          annual_energy_consumption: "400 kWh",
          door_panel_material: "Metal",
          colours: "Black Glass",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "Yes",
          adjustable_leg: "2",
          exposed_cord_length: "",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh TMF 640 (Inox)",
        handle: "purefresh-tmf-640",
        image: "",
        physical_characteristics: {
          total_net_capacity: "635L",
          net_fridge_capacity: "490L",
          net_freezer_capacity: "145L",
          type: "Top Mount",
          door_split: "65/35",
          product_dimension: "834 X 746 X 1870mm",
          packing_dimension: "873 X 769 X 1932mm",
          net_weight: "85Kg",
          gross_weight: "94Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "39dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "13hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "4",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "3",
          convertible_zone_drawer: "No",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "1",
          freezer_transparent_door_basket: "2",
          freezer_drawer: "0",
        },
        controls: {
          temperature_control_panel: "Electronic",
          external_led_display: "Yes",
          super_freeze_mode: "N/A",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "Fridge 2°C for 50 hours",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF250018 (3 Ticks)",
          annual_energy_consumption: "448 kWh",
          door_panel_material: "Metal",
          colours: "Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "No",
          adjustable_leg: "2",
          exposed_cord_length: "1.6m",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh BMF 330 (Inox)",
        handle: "purefresh-bmf-330",
        image: "",
        physical_characteristics: {
          total_net_capacity: "326L",
          net_fridge_capacity: "222L",
          net_freezer_capacity: "104L",
          type: "Bottom Mount",
          door_split: "55/45",
          product_dimension: "600 X 685 X 1840mm",
          packing_dimension: "640 X 715 X 1931mm",
          net_weight: "66Kg",
          gross_weight: "72Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "10hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "3",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "3",
          convertible_zone_drawer: "Yes",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "-",
          freezer_transparent_door_basket: "-",
          freezer_drawer: "2",
        },
        controls: {
          temperature_control_panel: "Electronic",
          external_led_display: "Yes",
          super_freeze_mode: "Freezer -25°C (Fixed) for 50 hours",
          holiday_mode: "-",
          eco_mode: "Freezer at -18°C (Fixed), Fridge 5°C (fixed)",
          power_cool: "N/A",
          door_alarm: "Yes (Not avail. for freezer compartment)",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240105 (3 Ticks)",
          annual_energy_consumption: "308 kWh",
          door_panel_material: "Metal",
          colours: "Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "Yes",
          adjustable_leg: "2",
          exposed_cord_length: "1.8m",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh BMF 420 (Inox)",
        handle: "purefresh-bmf-420",
        image: "",
        physical_characteristics: {
          total_net_capacity: "417L",
          net_fridge_capacity: "311L",
          net_freezer_capacity: "106L",
          type: "Bottom Mount",
          door_split: "60/40",
          product_dimension: "703 x 689 x 1725mm",
          packing_dimension: "764 x 740 x 1819mm",
          net_weight: "72Kg",
          gross_weight: "79Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "10hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "4",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "4",
          convertible_zone_drawer: "No",
          movable_twist_ice_maker: "Yes (Fixed)",
          freezer_tempered_glass_shelf: "-",
          freezer_transparent_door_basket: "-",
          freezer_drawer: "3",
        },
        controls: {
          temperature_control_panel: "Electronic",
          external_led_display: "Yes",
          super_freeze_mode: "Freezer -32°C for 4 hours",
          holiday_mode: "Fridge chamber turns off.",
          eco_mode: "-",
          power_cool: "Fridge 2°C for 2 hours",
          door_alarm: "Yes (Not avail. for freezer compartment)",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF250004 (3 Ticks)",
          annual_energy_consumption: "343 kWh",
          door_panel_material: "Metal",
          colours: "Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "Yes",
          adjustable_leg: "2",
          exposed_cord_length: "1.5m",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh SBSi 560 (Space Grey)",
        handle: "purefresh-sbsi-560",
        image: "",
        physical_characteristics: {
          total_net_capacity: "556L",
          net_fridge_capacity: "372L",
          net_freezer_capacity: "184L",
          type: "Side By Side",
          door_split: "55/45",
          product_dimension: "911 x 706 x 1780mm",
          packing_dimension: "968 x 750 x 1845mm",
          net_weight: "97Kg",
          gross_weight: "107Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "10-15",
        },
        storage: {
          fridge_tempered_glass_shelf: "4",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "4",
          convertible_zone_drawer: "",
          movable_twist_ice_maker: "Automatic: Cubed Ice, Crushed Ice & Water",
          freezer_tempered_glass_shelf: "3",
          freezer_transparent_door_basket: "2",
          freezer_drawer: "2",
        },
        controls: {
          temperature_control_panel: "Electronic",
          external_led_display: "Yes",
          super_freeze_mode:
            "QUICK FREEZE: Runs for 24hrs or until reaches -28°C",
          holiday_mode: "",
          eco_mode: "N/A",
          power_cool: "QUICK COOL: 2°C for 150mins",
          door_alarm: "Yes",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF250015 (3 Ticks)",
          annual_energy_consumption: "395 kWh",
          door_panel_material: "Metal",
          colours: "Space Grey",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "No",
          adjustable_leg: "2",
          exposed_cord_length: "2.4m",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh SBS 550",
        handle: "purefresh-sbs-550",
        image: "",
        physical_characteristics: {
          total_net_capacity: "552L",
          net_fridge_capacity: "362L",
          net_freezer_capacity: "190L",
          type: "Side By Side",
          door_split: "65/35",
          product_dimension: "910 x 632.8 x 1785.8mm",
          packing_dimension: "978 x 678 x 1875mm",
          net_weight: "75kg",
          gross_weight: "82kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter: "Silver-Ion Ceramic Deodorizer (Fridge) + Deodorising Module (Freezer)",
          storage_time_during_power_off: "10hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "4",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "3",
          convertible_zone_drawer: "",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "4",
          freezer_transparent_door_basket: "3",
          freezer_drawer: "2",
        },
        controls: {
          temperature_control_panel: "Electronic",
          external_led_display: "Yes",
          super_freeze_mode: "QUICK FREEZE: -32°C",
          holiday_mode: "QUICK COOL: Fridge 2°C for 150mins",
          eco_mode: "Freezer -17 to 18°C | Fridge 4 to 7°C",
          power_cool: "N/A",
          door_alarm: "Yes",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF260020 (3 Ticks)",
          annual_energy_consumption: "422 kWh",
          door_panel_material: "Metal",
          colours: "Inox, Dark Inox",
          handle_type: "Recessed",
          metal_back: "N/A",
          wheel: "2",
          reversible_door: "No",
          adjustable_leg: "2",
          exposed_cord_length: "",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh SBS 600 (Black Inox)",
        handle: "prism-purefresh-sbs600-refrigerator",
        image: "",
        physical_characteristics: {
          total_net_capacity: "602L",
          net_fridge_capacity: "375L",
          net_freezer_capacity: "227L",
          type: "Side By Side",
          door_split: "55/45",
          product_dimension: "910 X 730 X 1770mm",
          packing_dimension: "972 X 770 X 1862mm",
          net_weight: "90Kg",
          gross_weight: "100Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter: "Yes",
          storage_time_during_power_off: "10hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "4",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "5",
          convertible_zone_drawer: "",
          movable_twist_ice_maker: "Yes",
          freezer_tempered_glass_shelf: "4",
          freezer_transparent_door_basket: "4",
          freezer_drawer: "2",
        },
        controls: {
          temperature_control_panel: "Electronic",
          external_led_display: "Yes",
          super_freeze_mode: "Freezer -25°C (Fixed) for 50 hours",
          holiday_mode:
            "Freezer at -14 to 22°C  (options), Fridge 17°C (fixed)",
          eco_mode: "Freezer at -16°C (Fixed), Fridge 6°C (fixed)",
          power_cool: "N/A",
          door_alarm: "Yes",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240015 (3 Ticks)",
          annual_energy_consumption: "471 kWh",
          door_panel_material: "Metal",
          colours: "Black Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "4",
          reversible_door: "No",
          adjustable_leg: "2",
          exposed_cord_length: "",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "Inspire SBS 630",
        handle: "inspire-sbs-630",
        image: "",
        physical_characteristics: {
          total_net_capacity: "627L",
          net_fridge_capacity: "407L",
          net_freezer_capacity: "220L",
          type: "Side By Side",
          door_split: "55/45",
          product_dimension: "911 X 733 X 1780mm",
          packing_dimension: "968 X 790 X 1845mm",
          net_weight: "95Kg",
          gross_weight: "105Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter:
            "Yes (Anti-Odor + Anti-Bacterial Filter)",
          storage_time_during_power_off: "10-15",
        },
        storage: {
          fridge_tempered_glass_shelf: "4",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "4",
          convertible_zone_drawer: "No",
          movable_twist_ice_maker: "Yes (With Scoop & Measuring Cup)",
          freezer_tempered_glass_shelf: "4",
          freezer_transparent_door_basket: "4",
          freezer_drawer: "2",
        },
        controls: {
          temperature_control_panel: "Electronic Colour",
          external_led_display: "Yes",
          super_freeze_mode:
            "QUICK FREEZE: Runs for 24hrs or until reaches -28°C",
          holiday_mode: "SMART: Fridge 5°C, Freezer -18°C",
          eco_mode: "N/A",
          power_cool: "QUICK COOL: 2°C for 150mins",
          door_alarm: "Yes",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF250050 (3 Ticks)",
          annual_energy_consumption: "439 kWh",
          door_panel_material: "Matte Glass (AG Glass)",
          colours:
            "Sky Blue, Pastel Pink, Pastel Beige, Matte White, Matte Black",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "No",
          adjustable_leg: "2",
          exposed_cord_length: "2.4m",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "Inspire FDR 570",
        handle: "inspire-fdr-570",
        image: "",
        physical_characteristics: {
          total_net_capacity: "569L",
          net_fridge_capacity: "365L",
          net_freezer_capacity: "204L",
          type: "Four Door",
          door_split: "55/45",
          product_dimension: "911 X 706 X 1830mm",
          packing_dimension: "968 X 750 X 1870mm",
          net_weight: "99Kg",
          gross_weight: "108Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter:
            "Yes (Anti-Odor + Anti-Bacterial Filter)",
          storage_time_during_power_off: "10-15",
        },
        storage: {
          fridge_tempered_glass_shelf: "3",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "6",
          convertible_zone_drawer: "No",
          movable_twist_ice_maker: "Yes (With Scoop & Measuring Cup)",
          freezer_tempered_glass_shelf: "2",
          freezer_transparent_door_basket: "-",
          freezer_drawer: "4 deep drawers",
        },
        controls: {
          temperature_control_panel: "Electronic Colour",
          external_led_display: "Yes",
          super_freeze_mode:
            "QUICK FREEZE: Runs for 24hrs or until reaches -28°C",
          holiday_mode: "SMART: Fridge 5°C, Freezer -18°C",
          eco_mode: "N/A",
          power_cool: "QUICK COOL: 2°C for 150mins",
          door_alarm: "Yes",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240085 (3 Ticks)",
          annual_energy_consumption: "365 kWh",
          door_panel_material: "Matte Glass (AG Glass)",
          colours:
            "Sky Blue, Pastel Pink, Pastel Beige, Matte White, Matte Black",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "No",
          adjustable_leg: "2",
          exposed_cord_length: "2.4m",
          vacuum_insulation_panels: "Yes",
        },
      },
      {
        name: "PureFresh FDR 440 (Space Grey)",
        handle: "prism-purefresh-fdr-440-four-door-refrigerator",
        image: "",
        physical_characteristics: {
          total_net_capacity: "436L",
          net_fridge_capacity: "288L",
          net_freezer_capacity: "148L",
          type: "Four Door",
          door_split: "55/45",
          product_dimension: "836 X 636 X 1830mm",
          packing_dimension: "893 X 680 X 1870mm",
          net_weight: "90Kg",
          gross_weight: "99Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter:
            "Yes (Anti-Odor + Anti-Bacterial Filter)",
          storage_time_during_power_off: "10-15",
        },
        storage: {
          fridge_tempered_glass_shelf: "3",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "4",
          convertible_zone_drawer: "No",
          movable_twist_ice_maker: "Yes (With Scoop & Measuring Cup)",
          freezer_tempered_glass_shelf: "2",
          freezer_transparent_door_basket: "-",
          freezer_drawer: "4 deep drawers",
        },
        controls: {
          temperature_control_panel: "Electronic Colour",
          external_led_display: "Yes",
          super_freeze_mode:
            "QUICK FREEZE: Runs for 24hrs or until reaches -28°C",
          holiday_mode: "SMART: Fridge 5°C, Freezer -18°C",
          eco_mode: "N/A",
          power_cool: "QUICK COOL: 2°C for 150mins",
          door_alarm: "Yes",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240087 (3 Ticks)",
          annual_energy_consumption: "338 kWh",
          door_panel_material: "Metal",
          colours: "Space Grey",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "No",
          adjustable_leg: "2",
          exposed_cord_length: "2.4m",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "PureFresh FDR 570 (Space Grey)",
        handle: "purefresh-fdr-570",
        image: "",
        physical_characteristics: {
          total_net_capacity: "569L",
          net_fridge_capacity: "365L",
          net_freezer_capacity: "204L",
          type: "Four Door",
          door_split: "55/45",
          product_dimension: "911 X 706 X 1830mm",
          packing_dimension: "968 X 750 X 1870mm",
          net_weight: "99Kg",
          gross_weight: "108Kg",
        },
        performance: {
          compressor: "Inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "Yes",
          no_frost_technology: "Yes",
          defrosting_system: "Automatic",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter:
            "Yes (Anti-Odor + Anti-Bacterial Filter)",
          storage_time_during_power_off: "10-15",
        },
        storage: {
          fridge_tempered_glass_shelf: "3",
          crisper_drawer: "2",
          fridge_transparent_door_basket: "6",
          convertible_zone_drawer: "No",
          movable_twist_ice_maker: "Yes (With Scoop & Measuring Cup)",
          freezer_tempered_glass_shelf: "2",
          freezer_transparent_door_basket: "-",
          freezer_drawer: "4 deep drawers",
        },
        controls: {
          temperature_control_panel: "Electronic Colour",
          external_led_display: "Yes",
          super_freeze_mode:
            "QUICK FREEZE: Runs for 24hrs or until reaches -28°C",
          holiday_mode: "SMART: Fridge 5°C, Freezer -18°C",
          eco_mode: "N/A",
          power_cool: "QUICK COOL: 2°C for 150mins",
          door_alarm: "Yes",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240085 (3 Ticks)",
          annual_energy_consumption: "365 kWh",
          door_panel_material: "Metal",
          colours: "Space Grey",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "2",
          reversible_door: "No",
          adjustable_leg: "2",
          exposed_cord_length: "2.4m",
          vacuum_insulation_panels: "Yes",
        },
      },
      {
        name: "MB 50 (Black Inox)",
        handle: "purefresh-mb50",
        image: "",
        physical_characteristics: {
          total_net_capacity: "48L",
          net_fridge_capacity: "44L",
          net_freezer_capacity: "Fresh Compartment: 4L",
          type: "Mini Bar",
          door_split: "-",
          product_dimension: "445 X 470 X 501mm",
          packing_dimension: "460 X 500 X 530mm",
          net_weight: "13.3Kg",
          gross_weight: "14.6Kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "-",
          no_frost_technology: "-",
          defrosting_system: "Manual",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter: "-",
          storage_time_during_power_off: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "1",
          crisper_drawer: "-",
          fridge_transparent_door_basket: "2",
          convertible_zone_drawer: "N/A",
          movable_twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          temperature_control_panel: "Mechanical Knob",
          external_led_display: "No",
          super_freeze_mode: "-",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "N/A",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240100 (3 Ticks)",
          annual_energy_consumption: "133 kWh",
          door_panel_material: "Metal",
          colours: "Black Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "No",
          reversible_door: "Yes",
          adjustable_leg: "2",
          exposed_cord_length: "1.2m",
          vacuum_insulation_panels: "Yes",
        },
      },
      {
        name: "MB 90 (Black Inox)",
        handle: "purefresh-mb-90",
        image: "",
        physical_characteristics: {
          total_net_capacity: "91L",
          net_fridge_capacity: "79L",
          net_freezer_capacity: "Fresh Compartment: 12L",
          type: "Mini Bar",
          door_split: "-",
          product_dimension: "445 X 470 X 835mm",
          packing_dimension: "460 X 500 X 880mm",
          net_weight: "19Kg",
          gross_weight: "22Kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "-",
          no_frost_technology: "-",
          defrosting_system: "Manual",
          noise_level: "40dB",
          ceramic_activated_carbon_air_filter: "-",
          storage_time_during_power_off: "N/A",
        },
        storage: {
          fridge_tempered_glass_shelf: "2",
          crisper_drawer: "1",
          fridge_transparent_door_basket: "3",
          convertible_zone_drawer: "N/A",
          movable_twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          temperature_control_panel: "Mechanical Knob",
          external_led_display: "No",
          super_freeze_mode: "-",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "N/A",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "ELS-PRS-RF240109 (3 Ticks)",
          annual_energy_consumption: "136 kWh",
          door_panel_material: "Metal",
          colours: "Black Inox",
          handle_type: "Recessed",
          metal_back: "Yes",
          wheel: "No",
          reversible_door: "Yes",
          adjustable_leg: "2",
          exposed_cord_length: "1.2m",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "FreezeMaster CFZ 100",
        handle: "freezemaster-chest-freezer-cfz100",
        image: "",
        physical_characteristics: {
          total_net_capacity: "100L",
          net_fridge_capacity: "-",
          net_freezer_capacity: "-",
          type: "Chest",
          door_split: "-",
          product_dimension: "545 X 480 X 855mm",
          packing_dimension: "575 X 495 X 890mm",
          net_weight: "20Kg",
          gross_weight: "22Kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "-",
          no_frost_technology: "No",
          defrosting_system: "Manual",
          noise_level: "42dB",
          ceramic_activated_carbon_air_filter: "-",
          storage_time_during_power_off: "11hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "N/A",
          crisper_drawer: "N/A",
          fridge_transparent_door_basket: "N/A",
          convertible_zone_drawer: "N/A",
          movable_twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          temperature_control_panel: "External Digital Display",
          external_led_display: "Yes",
          super_freeze_mode: "Yes",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "N/A",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "N/A",
          annual_energy_consumption: "0.81 kWh",
          door_panel_material: "Metal (Foam within)",
          colours: "White",
          handle_type: "External",
          metal_back: "-",
          wheel: "Yes",
          reversible_door: "No",
          adjustable_leg: "-",
          exposed_cord_length: "1.6m",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "FreezeMaster CFZ 150",
        handle: "freezemaster-cfz-150",
        image: "",
        physical_characteristics: {
          total_net_capacity: "150L",
          net_fridge_capacity: "-",
          net_freezer_capacity: "-",
          type: "Chest",
          door_split: "-",
          product_dimension: "705 X 550 X 850mm",
          packing_dimension: "730 X 575 X 885mm",
          net_weight: "24Kg",
          gross_weight: "27Kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "-",
          no_frost_technology: "No",
          defrosting_system: "Manual",
          noise_level: "42dB",
          ceramic_activated_carbon_air_filter: "-",
          storage_time_during_power_off: "18hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "N/A",
          crisper_drawer: "N/A",
          fridge_transparent_door_basket: "N/A",
          convertible_zone_drawer: "N/A",
          movable_twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          temperature_control_panel: "External Digital Display",
          external_led_display: "Yes",
          super_freeze_mode: "Yes",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "N/A",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "N/A",
          annual_energy_consumption: "0.92 kWh",
          door_panel_material: "Metal (Foam within)",
          colours: "White",
          handle_type: "External",
          metal_back: "-",
          wheel: "Yes",
          reversible_door: "No",
          adjustable_leg: "-",
          exposed_cord_length: "1.6m",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "FreezeMaster CFZ 200",
        handle: "freezemaster-cfz-200",
        image: "",
        physical_characteristics: {
          total_net_capacity: "200L",
          net_fridge_capacity: "-",
          net_freezer_capacity: "-",
          type: "Chest",
          door_split: "-",
          product_dimension: "910 X 550 X 850mm",
          packing_dimension: "934 X 575 X 885mm",
          net_weight: "27Kg",
          gross_weight: "31Kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "-",
          no_frost_technology: "No",
          defrosting_system: "Manual",
          noise_level: "42dB",
          ceramic_activated_carbon_air_filter: "-",
          storage_time_during_power_off: "20hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "N/A",
          crisper_drawer: "N/A",
          fridge_transparent_door_basket: "N/A",
          convertible_zone_drawer: "N/A",
          movable_twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          temperature_control_panel: "External Digital Display",
          external_led_display: "Yes",
          super_freeze_mode: "Yes",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "N/A",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "N/A",
          annual_energy_consumption: "1.15 kWh",
          door_panel_material: "Metal (Foam within)",
          colours: "White",
          handle_type: "External",
          metal_back: "-",
          wheel: "Yes",
          reversible_door: "No",
          adjustable_leg: "-",
          exposed_cord_length: "1.6m",
          vacuum_insulation_panels: "No",
        },
      },
      {
        name: "FreezeMaster CFZ 380",
        handle: "freezemaster-cfz-380",
        image: "",
        physical_characteristics: {
          total_net_capacity: "380L",
          net_fridge_capacity: "-",
          net_freezer_capacity: "-",
          type: "Chest",
          door_split: "-",
          product_dimension: "1300 X 705 X 850mm",
          packing_dimension: "1336 X 748 X 885mm",
          net_weight: "43Kg",
          gross_weight: "50Kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "-",
          no_frost_technology: "No",
          defrosting_system: "Manual",
          noise_level: "42dB",
          ceramic_activated_carbon_air_filter: "-",
          storage_time_during_power_off: "34hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "N/A",
          crisper_drawer: "N/A",
          fridge_transparent_door_basket: "N/A",
          convertible_zone_drawer: "N/A",
          movable_twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          temperature_control_panel: "External Digital Display",
          external_led_display: "Yes",
          super_freeze_mode: "Yes",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "N/A",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "N/A",
          annual_energy_consumption: "1.57 kWh",
          door_panel_material: "Metal (Foam within)",
          colours: "White",
          handle_type: "External",
          metal_back: "-",
          wheel: "Yes",
          reversible_door: "No",
          adjustable_leg: "-",
          exposed_cord_length: "1.6m",
          vacuum_insulation_panels: "No",
        },
      },
      /*
      {
        name: "FreezeMaster CFZ 510",
        handle: "freezemaster-cfz-510",
        image: "",
        physical_characteristics: {
          total_net_capacity: "510L",
          net_fridge_capacity: "-",
          net_freezer_capacity: "-",
          type: "Chest",
          door_split: "-",
          product_dimension: "1640 X 705 X 880mm",
          packing_dimension: "1668 X 736 X 860mm",
          net_weight: "58Kg",
          gross_weight: "66Kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "-",
          no_frost_technology: "No",
          defrosting_system: "Manual",
          noise_level: "50dB",
          ceramic_activated_carbon_air_filter: "-",
          storage_time_during_power_off: "40hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "N/A",
          crisper_drawer: "N/A",
          fridge_transparent_door_basket: "N/A",
          convertible_zone_drawer: "N/A",
          movable_twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          temperature_control_panel: "External Digital Display",
          external_led_display: "Yes",
          super_freeze_mode: "Yes",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "N/A",
          door_alarm: "N/A",
        },
        design_build: {
          energy_label_certificate_number: "N/A",
          annual_energy_consumption: "1.99 kWh",
          door_panel_material: "Metal (Foam within)",
          colours: "White",
          handle_type: "External",
          metal_back: "-",
          wheel: "Yes",
          reversible_door: "No",
          adjustable_leg: "-",
          exposed_cord_length: "1.6m",
          vacuum_insulation_panels: "No",
        },
      },
      */
      {
        name: "FreezeMaster CFZ 710",
        handle: "freezemaster-cfz-710",
        image: "",
        physical_characteristics: {
          total_net_capacity: "710L",
          net_fridge_capacity: "-",
          net_freezer_capacity: "-",
          type: "Chest",
          door_split: "-",
          product_dimension: "1905 X 815 X 880mm",
          packing_dimension: "1954 X 888 X 885mm",
          net_weight: "72Kg",
          gross_weight: "81Kg",
        },
        performance: {
          compressor: "Non-inverter",
          refrigerant: "R600a",
          multi_zone_cooling: "-",
          no_frost_technology: "No",
          defrosting_system: "Manual",
          noise_level: "50dB",
          ceramic_activated_carbon_air_filter: "-",
          storage_time_during_power_off: "48hrs",
        },
        storage: {
          fridge_tempered_glass_shelf: "N/A",
          crisper_drawer: "N/A",
          fridge_transparent_door_basket: "N/A",
          convertible_zone_drawer: "N/A",
          movable_twist_ice_maker: "N/A",
          freezer_tempered_glass_shelf: "N/A",
          freezer_transparent_door_basket: "N/A",
          freezer_drawer: "N/A",
        },
        controls: {
          temperature_control_panel: "External Digital Display",
          external_led_display: "Yes",
          super_freeze_mode: "Yes",
          holiday_mode: "N/A",
          eco_mode: "N/A",
          power_cool: "2.13",
          door_alarm: "SN-T",
        },
        design_build: {
          energy_label_certificate_number: "N/A",
          annual_energy_consumption: "2.13 kWh",
          door_panel_material: "Metal (Foam within)",
          colours: "White",
          handle_type: "External",
          metal_back: "-",
          wheel: "Yes",
          reversible_door: "No",
          adjustable_leg: "-",
          exposed_cord_length: "1.6m",
          vacuum_insulation_panels: "No",
        },
      },
    ];

    return data;
  }

  async function getProductData(handle) {
    return await (await fetch(`/products/${handle}.js`)).json();
  }
  
  function assignCssVariables() {
    const comparePopup = $(".compare_fridge_popup")[0];

    setInterval(() => {
      comparePopup.style.setProperty(
        "--nav-height",
        `${$("#shopify-section-header").height()}px`,
      );
    }, 50);
  }
})();
